














































import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  Order,
  OrderComment
} from '@/interfaces/order.interface';
import {namespace} from 'vuex-class';
import {User} from '@/interfaces/user.interface';
import PermissionsService from '../services/permissions.service';

const ordersModule = namespace('orders');
const usersModule = namespace('users');

@Component
export default class OrderDetailsComments extends Vue {
  @Prop({default: []}) order!: Order;
  @ordersModule.Action fetchComments: any;
  @ordersModule.Action createComment: any;
  @ordersModule.Action deleteCommentWithConfirmation: any;
  @usersModule.State users: User[];

  comment: string = '';

  mounted() {
    this.fetchComments({orderUuid: this.order.uuid});
  }

  get comments(): OrderComment[] {
    const comments: OrderComment[] = this.order.comments || [];
    return comments.sort((a, b) => a.createdAt > b.createdAt ? -1 : 1);
  }

  getUserByUuid(uuid: string): User {
    return this.users.find(u => u.uuid === uuid) || {};
  }

  saveComment(): void {
    this.createComment({
      orderUuid: this.order.uuid,
      comment: this.comment
    });
    this.clearComment();
  }

  clearComment(): void {
    this.comment = '';
  }

  del(comment: OrderComment) {
    this.deleteCommentWithConfirmation({comment});
  }

  get canCreateComments(): boolean {
    return PermissionsService.can('comments', 'create');
  }

  get canDeleteComments(): boolean {
    return PermissionsService.can('comments', 'delete');
  }

  canDeleteOwnComment(comment: OrderComment): boolean {
    return PermissionsService.can('comments', 'delete:own', undefined, comment.userUuid);
  }
}
